<template>
	<div>
		<b-row class="print-row mt-3" v-if="Character.Equipment.Augmentation.length > 0">
			<b-col class="col">
				<h4>Augmentations</h4>
			</b-col>
		</b-row>
		<b-row class="print-row mt-3" v-for="(augment, index) in Character.Equipment.Augmentation" :key="'details-equipment-autments-'+index" style="page-break-inside: avoid;">
			<b-col cols="2">
				<strong>{{augment.Name}}</strong>
			</b-col>
			<b-col cols="10" class="pre">
				{{augment.Description}}
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
	}
}
</script>

<style scoped>

</style>